export default __webpack_public_path__ + "static/media/news_certificate.7a8bb8b8.jpg";